export default class Color {
    constructor() {
        this.teams = ['thecatswhiskers', 'cozmez', 'akanyatsura', 'visty', 'amprule', 't_1nm8', 'gokuluck', 'bae'];

        this.init();
    }

    init() {
        window.addEventListener('load', () => {
            setTimeout(() => {
                this.setIntervalColor();
            }, 1000);
        });
    }

    setIntervalColor() {
        let currentIndex = 0;
        const setIntervalTime = 10000; //10秒

        // 配列を一定期間で繰り返して変更する関数
        const cycleColors = () => {
            document.body.setAttribute('data-color', this.teams[currentIndex]);
            currentIndex = (currentIndex + 1) % this.teams.length; // インデックスを更新して配列をループ
        };

        setInterval(cycleColors, setIntervalTime);
    }
}
